<template>
    <!-- 新分组 -->
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >

        <v-form ref="form" :model="ruleForm" :rules="rules">
            <v-form-item  prop="topic" >
            <template slot="label">
              <span class="required">*</span>
              <span>Topic</span>
            </template>
            <v-input type="text" name="topic" v-model="ruleForm.topic"></v-input>
          </v-form-item>

          <v-form-item  prop="topic_power" >
            <template slot="label">
              <span class="required">*</span>
              <span>topic权限</span>
            </template>
            <v-select id="topic_power" insertContains="topic_power" name="topic_power" v-model="ruleForm.topic_power" :options="powerOptins"></v-select>

          </v-form-item>

          <v-form-item  prop="topic_desc" >
            <template slot="label">
              <span class="required">*</span>
              <span>描述</span>
            </template>
            <v-input type="textarea" class="remarks" name="topic_desc" :maxlength="200" v-model="ruleForm.topic_desc" show-word-limit></v-input>
          </v-form-item>

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>

    </div>

</template>

<script>
  import { copy } from '@/common/libs/utils';

export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    productKey:{}

  },
    data() {
      return {
        rules: {
          topic: copy([{
            type: "topic"
          }])
        },
        ruleForm:{
          topic: "", //名称
          topic_power: "",  //权限
          topic_desc: "",  //描述
          topic_type: 'diy',
          topic_use:'diy',
          app_id: sessionStorage.getItem("appid") || "",
          product_key: this.productKey,
        },
        powerOptins:[
            {
                label: '发布',
                value: 'pub'
            },{
                label: '订阅',
                value: 'sub'
            },
        ],
        dialogTitle: "自定义Topic",

        isShow:false,
        upTips:true,
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){

      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }

        let submitData = { ...this.ruleForm };
        this.$post("/td/td-iot-api/iot/topic/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
